"use client";

import { useEffect, useState } from "react";

import { UpdatedAt } from "./updated-at";

export function FakeUpdatedAt() {
  const [date, setDate] = useState<Date | null>(null);

  useEffect(() => {
    setDate(new Date());
  }, []);

  return <span>{date && <UpdatedAt date={date} />}</span>;
}
